// extracted by mini-css-extract-plugin
export default {"Containers":"Bags_Containers__S0CVw"};